// Glow Cyber Pong / Air Hockey 60Hz Server Engine
export class PongEngine {
  constructor(io, room) {
    this.io = io;
    this.room = room;
    this.tableWidth = 800;
    this.tableHeight = 500;
    this.player1 = null; // Left
    this.player2 = null; // Right
    this.p1Y = 250;
    this.p2Y = 250;
    this.ball = { x: 400, y: 250, vx: 6.0, vy: 3.5, radius: 10 };
    this.score1 = 0;
    this.score2 = 0;
    this.maxScore = 7;
    this.loopInterval = null;
  }

  start() {
    this.player1 = this.room.players[0] || null;
    this.player2 = this.room.players[1] || null;

    if (!this.player2 && this.room.settings?.fillBots !== false) {
      this.player2 = { id: 'bot_pong', name: '🤖 PongBot', isBot: true };
    }

    this.score1 = 0;
    this.score2 = 0;
    this.resetBall(1);

    this.io.to(this.room.code).emit('pong_started', {
      player1: this.player1,
      player2: this.player2,
      tableWidth: this.tableWidth,
      tableHeight: this.tableHeight
    });

    if (this.loopInterval) clearInterval(this.loopInterval);
    this.loopInterval = setInterval(() => this.update(), 1000 / 60);
  }

  handlePaddle(playerId, y) {
    if (this.player1 && this.player1.id === playerId) {
      this.p1Y = Math.max(50, Math.min(this.tableHeight - 50, y));
    } else if (this.player2 && this.player2.id === playerId) {
      this.p2Y = Math.max(50, Math.min(this.tableHeight - 50, y));
    }
  }

  resetBall(direction = 1) {
    this.ball.x = this.tableWidth / 2;
    this.ball.y = this.tableHeight / 2;
    this.ball.vx = (direction > 0 ? 6.5 : -6.5);
    this.ball.vy = (Math.random() - 0.5) * 6;
  }

  update() {
    this.ball.x += this.ball.vx;
    this.ball.y += this.ball.vy;

    // Top / Bottom wall bounce
    if (this.ball.y - this.ball.radius < 0) {
      this.ball.y = this.ball.radius;
      this.ball.vy = Math.abs(this.ball.vy);
    } else if (this.ball.y + this.ball.radius > this.tableHeight) {
      this.ball.y = this.tableHeight - this.ball.radius;
      this.ball.vy = -Math.abs(this.ball.vy);
    }

    // Left Paddle Bounce (P1)
    const paddleH = 90;
    if (this.ball.x - this.ball.radius <= 30 && this.ball.x + this.ball.radius >= 15) {
      if (Math.abs(this.ball.y - this.p1Y) < paddleH / 2) {
        this.ball.vx = Math.abs(this.ball.vx) * 1.05; // Speed up
        this.ball.vy = (this.ball.y - this.p1Y) * 0.18;
      }
    }

    // Right Paddle Bounce (P2)
    if (this.ball.x + this.ball.radius >= this.tableWidth - 30 && this.ball.x - this.ball.radius <= this.tableWidth - 15) {
      if (Math.abs(this.ball.y - this.p2Y) < paddleH / 2) {
        this.ball.vx = -Math.abs(this.ball.vx) * 1.05;
        this.ball.vy = (this.ball.y - this.p2Y) * 0.18;
      }
    }

    // Score Check
    if (this.ball.x < 0) {
      this.score2++;
      this.io.to(this.room.code).emit('pong_score', { score1: this.score1, score2: this.score2 });
      if (this.score2 >= this.maxScore) {
        this.endGame(this.player2);
      } else {
        this.resetBall(1);
      }
    } else if (this.ball.x > this.tableWidth) {
      this.score1++;
      this.io.to(this.room.code).emit('pong_score', { score1: this.score1, score2: this.score2 });
      if (this.score1 >= this.maxScore) {
        this.endGame(this.player1);
      } else {
        this.resetBall(-1);
      }
    }

    // Bot paddle AI
    if (this.player2?.isBot) {
      const targetY = this.ball.x > 300 ? this.ball.y : 250;
      this.p2Y += (targetY - this.p2Y) * 0.14;
      this.p2Y = Math.max(50, Math.min(this.tableHeight - 50, this.p2Y));
    }

    this.io.to(this.room.code).emit('pong_state', {
      ball: this.ball,
      p1Y: this.p1Y,
      p2Y: this.p2Y
    });
  }

  endGame(winner) {
    if (this.loopInterval) clearInterval(this.loopInterval);
    this.io.to(this.room.code).emit('pong_gameOver', { winner });
  }

  destroy() {
    if (this.loopInterval) clearInterval(this.loopInterval);
  }
}
